
<div class="tab-content">
    <div id="districtapprovals" role="tabpanel" class="tab-pane active collapse show">
          <spinner [id]="'approvecomp'" [show]='activeSpinner'></spinner>
        <div class="row">
            <div class="col-md-12">
                <div class="tab" role="tabpanel">
                   
                    <div class="tab-content">
                        <div role="tabpanel" class="tab-pane fade active show" id="pending">
                            <div class="row" >
                                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                    <div class="btn-group float-right my-1" *ngIf="!userdetails['isReadOnly']">
                                        <!-- <button class="btn btn-info btn-sm mr-2" (click)="approveclick()" name="approval" type="button">Approve</button> -->
                                        <button  class="btn btn-info btn-sm mr-2" (click)="approveorrejectData('approve')" name="submit" type="button">{{'header.submit' | translate }}</button>
                                        <!-- <button class="btn btn-danger btn-sm" (click)="approveOrrejectclick('reject')" name="reject" type="button">Reject</button> -->
                                    </div>
                                    <div class="float-left my-1">
                                      <label>{{'header.assesmentyear' | translate }}<span class="text-star">*</span></label>
                                      <select [(ngModel)]="assessmentYear" class="form-control custom-selectbox">
                                          <option *ngFor="let year of yearDropDownList" value="{{year}}">{{year}}</option>
                                      </select>
                                    </div> &nbsp;&nbsp;
                                    <div class="float-left my-1" style="margin-left:10px" >
                                          <label>{{'dataSubs.month' | translate }}<span class="text-star">*</span></label>
                                          <select [(ngModel)]="monthlist['montharray']" class="form-control custom-selectbox">
                                            <option value="" [disabled]="true">{{'monthmaps.selcecttag' | translate }}</option>
                                            <option  *ngFor="let month of monthsList"  [value]="month.key">
                                                {{'monthmaps.' + month['value'] | translate}}</option>
                                          </select>
                                      </div>
                                      <!-- <div class="float-left my-1 ml-10">
                                        <label>{{'header.state' | translate }}</label>
                                        <select [(ngModel)]="selectedstate" class="form-control custom-selectbox" (change) = "showdistrictdropdown(selectedstate)">
                                        <option value="undefined">{{'tabledataforstates.all' | translate}}</option>
                                        <option *ngFor="let state of stateArrayList" value="{{state['uuid']}}">{{'tabledataforstates.' + state.name | translate}}</option>
                                        </select>
                                    </div>
                                    <div class="float-left my-1 ml-10" *ngIf="showdistdrop">
                                    <label>{{'header.district' | translate}}</label>
                                    <select [(ngModel)]="selectedistrict"  (change) = "getdistuuid(selectedistrict)" class="form-control custom-selectbox">
                                      <option value="undefined">{{'tabledataforstates.all' | translate}}</option>
                                      <option *ngFor="let district of DistrictList" value="{{district['uuid']}}">{{'districtsdata.' + district['name'] | translate}}</option>
                                    </select>
                                     </div> -->
                                     <div class="float-left my-1 ml-10">
                                        <label>{{'header.district' | translate }}</label>
                                        <select [(ngModel)]="formInputfilter['lu']" disabled="" class="form-control custom-selectbox">
                                          <option *ngFor="let state of userdetails['loggedUserData']['userProfile']['associatedlocationsDetails']"
                                            value="{{state['entityUUID']}}">{{'districtsdata.' + state['entityName'] | translate}}</option>
                                        </select>
                                      </div>

                                  <div class="float-left ml-10" style="margin-top:39px;">
                                      <button  class="btn btn-info btn-sm mr-2" (click)="getReports()" name="submit" type="button" type="button">{{'dataSubs.SUBMIT' | translate}}</button>

                                  </div>
                                </div>
                            </div>
  
                            <div class="row">
                                <div class="col-md-12">
                                    <div   class="table-responsive table-responsive-lg table-responsive-md table-responsive-sm">
                                        <!-- <cdk-virtual-scroll-viewport  #scrollViewport  -->
                                          <cdk-virtual-scroll-viewport  #scrollViewport 
                                          itemSize="50" [style.height]="tableData.length > 0 ? '500px' : '185px'">
                                        <table class="table text-center table-sm mt-1">
                                            <thead class="thead-light">
                                                <tr>
                                                    <th class="positiontest">
                                                        <div class="custom-control custom-checkbox"*ngIf="!userdetails['isReadOnly']">
                                                            <input type="checkbox" (change)="checkallset(checkall)"  name="selectall" [(ngModel)]="checkall" class="custom-control-input" id="selectall">
                                                            <label class="custom-control-label" for="selectall"></label>
                                                        </div>
                                                        <input type="checkbox" name="selectall" class="custom-control-input" id="selectall">
                                                    </th>
                                                    <th scope="col" class="positiontest">{{'dataSubs.sno' | translate}}</th>
                                                    <th>{{'dataSubs.distname' | translate}}</th>
                                                    <!-- <th>Rank</th> -->
                                                    <th>{{'dataSubs.scoregen'| translate}}</th>
                                                    <th *ngIf="!userdetails['isReadOnly']">{{'dataSubs.editreport'| translate}}</th>
                                                </tr>
                                            </thead>
                                            <tbody class="text-white">
                                              <ng-container *ngFor="let table of computedData;let i=index">
                                                      <tr>
                                                          <td>
                                                              <div class="custom-control custom-checkbox" *ngIf="!userdetails['isReadOnly']">
                                                                  <input type="checkbox" class="custom-control-input" [(ngModel)]="table['ischecked']" id="{{i+1}}">
                                                                  <label class="custom-control-label" for="{{i+1}}"></label>
                                                              </div>
                                                           </td>
                                                           <td>{{i+1}}</td>
                                                          <td>{{'districtsdata.' + checkvalue(table['name']) | translate}}</td>
                                                          <!-- <td>{{checkvalue(table['rank'])}}</td> -->
                                                          <td>{{checkscorevalue(table['score'])}}</td>
                                                          <td><a  class="pointer" title="View Data" (click)="infoClick(table, table['id'], table['name'],table['verified'],getLevel(datasubmit))" ><i class="fa fa-eye"></i></a></td>
                                                      </tr>
                                              </ng-container>
                                            </tbody>
                                        </table>
                                          </cdk-virtual-scroll-viewport>
                                        <!-- </cdk-virtual-scroll-viewport> -->
                                    </div>
                                    <div class="row" *ngIf="computedData.length == 0">
                                      <div class="col-12 nodata" >
                                        {{'infotab.nodata' | translate}}
                                       </div>
                                   </div>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
  
    </div>
  </div>
